export default __webpack_public_path__ + "static/media/wanted.38a75e38.mp3";